
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.257 4.647c.218.376.327.563.327.77 0 .206-.109.394-.327.77L8.216 7.98c-.218.376-.327.564-.507.667-.18.103-.398.103-.834.103H4.793c-.436 0-.654 0-.834-.103-.18-.103-.289-.291-.507-.667l-1.04-1.794c-.219-.375-.328-.563-.328-.77 0-.206.109-.393.327-.77l1.041-1.793c.218-.376.327-.563.507-.667.18-.103.398-.103.834-.103h2.082c.436 0 .654 0 .834.103.18.104.289.291.507.667l1.04 1.794zM17.589 9.647c.218.376.327.563.327.77 0 .206-.109.394-.327.77l-1.041 1.793c-.218.376-.327.564-.507.667-.18.103-.398.103-.834.103h-2.082c-.436 0-.654 0-.834-.103-.18-.103-.289-.291-.507-.667l-1.04-1.793c-.219-.376-.328-.564-.328-.77 0-.207.109-.394.327-.77l1.041-1.794c.218-.376.327-.563.507-.667.18-.103.398-.103.834-.103h2.082c.436 0 .654 0 .834.103.18.104.289.291.507.667l1.04 1.794zM9.257 13.813c.218.376.327.564.327.77 0 .207-.109.394-.327.77l-1.041 1.794c-.218.376-.327.563-.507.667-.18.103-.398.103-.834.103H4.793c-.436 0-.654 0-.834-.104-.18-.103-.289-.29-.507-.666l-1.04-1.794c-.219-.376-.328-.563-.328-.77 0-.206.109-.394.327-.77l1.041-1.793c.218-.376.327-.564.507-.667.18-.103.398-.103.834-.103h2.082c.436 0 .654 0 .834.103.18.103.289.291.507.667l1.04 1.793z","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    